import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppRcsFunctionOverviewVO } from '../Type/PackEntityAppRcsFunctionOverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	5G消息功能总览查询
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function func5gmessagequery(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityAppRcsFunctionOverviewVO>
export function func5gmessagequery(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityAppRcsFunctionOverviewVO extends { msg: unknown } ? PackEntityAppRcsFunctionOverviewVO['msg'] : undefined
>
export function func5gmessagequery(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/5g/message/query', {
		method: 'get',
		params: {
			aid,
			cid,
		},
		...(options || {}),
	})
}
